import { RouteObject } from'react-router-dom';
import { CreateTransfer } from'./components/create/CreateTransfer';

export const transferRoutes: RouteObject[] = [
 {
 path:'create/transfer',
 element: <CreateTransfer />,
 }
];
